module.exports = __webpack_public_path__ + "static/media/i-cursor.7b6d3a21.svg";